import moment from 'moment';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import DownloadCSV from '../../../../components/DownloadCSV';
import { getCRSAlertHistoryData } from '../../../../redux/actions/crs/crsRiskDetail';
import { getAMLSCommonUnifiedAlertCountByMetricName } from '../../../../redux/actions/common';
import { AlertHistoryModule } from '../../../../services/crs/apiModules/RiskDetailModules/alertHistoryModule';
import { CRS_CONSTANTS } from '../../../constants/crsContants';
import CRSTableContainer from '../CRSProfileTables/CRSTableContainer';
import { processDataFromProps } from '../riskDetailUtil';
import { convertDateInputToEpoch } from '../../../../util/timezone';
import { groupBy, map, min, sortBy } from 'lodash';
import { UNIFIED_ALERT_METRICS } from '../../../constants/commonConstants';

const { GET_DATA } = CRS_CONSTANTS;

/**
 * HistAlert main component
 */
class HistAlert extends React.Component {
  // eslint-disable-line react/prefer-stateless-function
  constructor(props) {
    super(props);
    this.state = {
      isChevronClicked: false,
      newDataFlag: true,
      alertsList: [], // hist alerts in the table
      hasMore: true,
      filterClicked: false,
      currentPage: 0,
      histData: [],
      filterApplied: false,
      tableWidth: '100%',
      dateRange: {
        startDate: moment().subtract(30, 'days').add(1, 'days'),
        endDate: moment(),
        activeRangeNo: 2
      }
    };

    this.dataUrlMap = {};
  }

  componentDidMount() {
    window.addEventListener('resize', this.updateTableWidth);
    this.fetchAlertHistory();
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateTableWidth);
  }

  onAlertHistDownload = async () => {
    this.setState({ histData: [] });
    const {
      dateRange: { startDate, endDate }
    } = this.state;
    const { AMLS_COMMON, HTTP_HEADERS } = CRS_CONSTANTS;
    const alertHistoryModule = new AlertHistoryModule(
      AMLS_COMMON,
      HTTP_HEADERS
    );
    const alertHistData = await alertHistoryModule.fetchAlertHistory({
      customerKey: this.props.customerKey,
      from: convertDateInputToEpoch(
        startDate.format('YYYY-MM-DDTHH:mm:ss.SSS[Z]'),
        true
      ),
      to: convertDateInputToEpoch(
        endDate.format('YYYY-MM-DDTHH:mm:ss.SSS[Z]'),
        true
      ),
      offset: 0,
      limit: 5000
    });

    const { alert_list } = alertHistData;
    if (alert_list.length === 0) {
      this.setState({ histData: [{}] });
      return false;
    }
    this.setState({ histData: alert_list });
  };

  onChevronClick = () => {
    this.setState({ isChevronClicked: !this.state.isChevronClicked });
  };

  onDateChange = (start, end, rangeNo) => {
    const newDateRange = {
      startDate: start,
      endDate: end,
      activeRangeNo: rangeNo
    };
    this.setState(
      {
        ...this.state,
        dateRange: newDateRange,
        newDataFlag: true,
        hasMore: true,
        currentPage: 0,
        filterClicked: false,
        activeOption: 0
      },
      () => {
        this.fetchAlertHistory();
      }
    );
  };

  onPaginationChange = async (page, pageSize) => {
    const {
      dateRange: { startDate, endDate },
      currentPage
    } = this.state;
    this.setState(
      {
        ...this.state,
        currentPage: page - 1
      },
      () => {
        this.fetchAlertHistory((page - 1) * pageSize);
      }
    );
  };

  onScrollToLoad = () => {
    const { currentPage, dateRange } = this.state;
    const { startDate, endDate } = dateRange;
    this.setState({
      ...this.state,
      newDataFlag: true,
      currentPage: currentPage + 1
    });

    const payload = {
      customerKey: this.props.customerKey,
      from: convertDateInputToEpoch(
        startDate.format('YYYY-MM-DDTHH:mm:ss.SSS[Z]'),
        true
      ),
      to: convertDateInputToEpoch(
        endDate.format('YYYY-MM-DDTHH:mm:ss.SSS[Z]'),
        true
      ),
      limit: 20,
      offset: (currentPage + 1) * 20,
      isScrolled: true
    };
    this.props.dispatch(getCRSAlertHistoryData(payload, GET_DATA));
  };

  getFileName = () => {
    const dateObj = new Date();
    const timestamp = dateObj.getTime();
    return `AlertHistory__${
      this.props.customerKey
    }--${this.state.dateRange.startDate.format(
      'DDMMYYYY'
    )}-to-${this.state.dateRange.endDate.format('DDMMYYYY')}__${timestamp}.csv`;
  };

  fetchAlertHistory = (offset = 0) => {
    const { dateRange } = this.state;
    const { startDate, endDate } = dateRange;
    const payload = {
      customerKey: this.props.customerKey,
      from: convertDateInputToEpoch(
        startDate.format('YYYY-MM-DDTHH:mm:ss.SSS[Z]'),
        true
      ),
      to: convertDateInputToEpoch(
        endDate.format('YYYY-MM-DDTHH:mm:ss.SSS[Z]'),
        true
      ),
      limit: 20,
      offset
    };
    this.props.dispatch(getCRSAlertHistoryData(payload, GET_DATA));
  };

  updateTableWidth = () => {
    const elem = document.getElementById('histTransactionContent');
    if (elem) {
      const computedStyle = window.getComputedStyle(elem, null);
      const newWidth = computedStyle.getPropertyValue('width');
      this.setState({
        tableWidth: parseInt(newWidth)
      });
    }
  };

  getCSVHeaders = () => {
    const csvHeaders = [];

    map(groupBy(this.props.GSConfig?.widgetConfig, 'columnName'), (v, k) => {
      const children = v.filter((col) => {
        return col.columnVisibility;
      });
      return {
        columnName: k,
        columnIndex: min(map(v, (i) => i.columnIndex)),
        children: children
      };
    })
      .filter((col) => col.children.length > 0)
      .sort((a, b) => a.columnIndex - b.columnIndex)
      .map((col) => {
        sortBy(col.children, ['columnIndex']).map((item) => {
          item.columnDetail
            .sort((a, b) => a.itemIndex - b.itemIndex)
            .map((itemDetail) => {
              let itemDetails = {};
              itemDetails.label = itemDetail.itemLabel;
              itemDetails.name = itemDetail.itemLabel;
              itemDetails.key = itemDetail.itemName;
              if (itemDetail.itemName === 'alertScore')
                itemDetails.key = 'detailedAlertScore';
              if (itemDetail.itemName === 'alertLevel')
                itemDetails.key = 'levelDowload';
              csvHeaders.push(itemDetails);
            });
        });
      });

    return csvHeaders;
  };

  render() {
    const { currentPage } = this.state;
    const { crsRiskDetailData } = this.props;
    const { alertHistoryResponse } = processDataFromProps(crsRiskDetailData);
    const { alert_list = [], isFetching, count } = alertHistoryResponse || {};
    return (
      <CRSTableContainer
        header="Alert History"
        GSConfig={this.props.GSConfig}
        onDateChange={this.onDateChange}
        data={alert_list}
        loadMore={() => {}}
        loading={isFetching}
        hasMore={false}
        actions={
          <DownloadCSV
            csvData={this.state.histData}
            csvHeaders={this.getCSVHeaders()}
            fileName={this.getFileName()}
            onDownloadClick={this.onAlertHistDownload}
          />
        }
        pagination={{
          total: count,
          current: currentPage + 1,
          pageSize: 20,
          onChange: this.onPaginationChange,
          showTotal: (total) => `${total} Records`,
          showSizeChanger: false
        }}
      />
    );
  }
}

HistAlert.propTypes = {
  dispatch: PropTypes.func,
  crsRiskDetailData: PropTypes.object,
  GSConfig: PropTypes.object,
  customerKey: PropTypes.string
};

/**
 * mapStateToProps
 * @param state
 * @param ownProps
 * @returns {{crsRiskDetailData: crsRiskDetailReducer}}
 */

function mapStateToProps(state, ownProps = {}) {
  return {
    crsRiskDetailData: state.crsRiskDetailReducer
  };
}

/**
 * mapDispatchToProps
 * @param dispatch
 * @param ownProps
 * @returns {{dispatch: *, navigateTo: navigateTo}}
 */
function mapDispatchToProps(dispatch, ownProps = {}) {
  return {
    dispatch
  };
}

/**
 * connect function for CRSRiskDetail page
 */
export default connect(mapStateToProps, mapDispatchToProps)(HistAlert);
